import { render, staticRenderFns } from "./ShowDetailsComponent.vue?vue&type=template&id=3f872eea&"
import script from "./ShowDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./ShowDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports